module.exports = __webpack_public_path__ + "img/news-list-eng-1.f793ccb4.png";